import { Link as RouterLink, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// @mui
import { AppBar, Box, Divider, Stack, Toolbar, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// components
import { bgBlur } from '../../utils/cssStyles';
import { HEADER, NAVBAR } from '../../store/constant';
import LogoModeAnimation from '../../components/logo/LogoModeAnimation';


// ----------------------------------------------------------------------

const StyledHeader = styled('header')(({ theme }) => ({
  top: 0,
  left: 0,
  lineHeight: 0,
  width: '100%',
  position: 'absolute',
  padding: theme.spacing(3, 3, 0),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 5, 0),
  },
}));


/* ======================================================================================= */

const HeaderRoot = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'isScroll',
})(({ isScroll, theme }) => ({
  ...bgBlur({ color: theme.palette.background.default }),
  boxShadow: 'none',
  backgroundColor: 'transparent',
  backdropFilter: 'blur(0px)',
  // backgroundImage: theme.palette.gradients.header1,
  transition: theme.transitions.create(['backdropFilter'], {
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${NAVBAR.WIDTH + 0}px)`,
  },
  ...(isScroll && {
    backdropFilter: 'blur(22px)'
  }),
}));



const ToolbarRoot = styled(Toolbar)(({ theme }) => ({
  alignItems: 'stretch',
  minHeight: `${HEADER.MOBILE_HEIGHT}px !important`,
  [theme.breakpoints.up('lg')]: {
    minHeight: HEADER.DESKTOP_HEIGHT,
    padding: theme.spacing(0, 6),
  },
}));

// ----------------------------------------------------------------------

export default function SimpleLayout({ disabledLink = false }) {
  const { t } = useTranslation();
  return (
    <>
      <HeaderRoot>
        <ToolbarRoot>
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
            sx={{
              mr: 1,
              color: 'text.primary',
            }}
          >
            {/* <LogoAnimation /> */}
            <LogoModeAnimation disabledLink={disabledLink} />
            {/* <Stack
              component={RouterLink}
              direction="row"
              alignItems="center"
              spacing={1.5}
              sx={{ mr: 1, color: 'text.primary', textDecoration: 'none' }}
              to="/honhai/app"
            >
              
              <Logo disabledLink />
              <Typography variant={'h4'} color={"#FFFFFF"}>
                {`中央總務平台`}
              </Typography>
            </Stack> */}
          </Stack>

          <Box sx={{ flexGrow: 1 }} />

        </ToolbarRoot>
      </HeaderRoot>
      <Outlet />
    </>
  );
}
